<template>
	<div class="regulatory-assistant-side-panel" :class="{ fullscreen }">
		<div class="header">
			<div class="title">
				<AppIcon :name="IconName.Sparkles" :size="16" />
				<span>{{ t("regulatoryAssistant.title") }}</span>
			</div>
			<button
				type="button"
				class="close-button"
				:title="t('callToActions.close')"
				:aria-label="t('callToActions.close')"
				@click="emit('close')"
			>
				<AppIcon :name="IconName.CloseSmall" :size="18" :stroke-width="1.2" />
			</button>
		</div>

		<RegulatoryAssistantPanel :locked="locked" @unlock="emit('unlock')" />
	</div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n"
import AppIcon from "@/components/AppIcon.vue"
import { IconName } from "@/components/icons/registry"
import RegulatoryAssistantPanel from "@/components/parcels/assistant/RegulatoryAssistantPanel.vue"

defineProps<{
	fullscreen?: boolean
	locked?: boolean
}>()

const emit = defineEmits<{
	close: []
	unlock: []
}>()

const { t } = useI18n()
</script>

<style scoped>
.regulatory-assistant-side-panel {
	position: fixed;
	top: 0;
	right: 0;
	z-index: 5;
	display: flex;
	flex-direction: column;
	width: var(--width-detail-panel);
	height: 100%;
	background-color: var(--neutral-0);
	box-shadow: var(--shadow-base-right);
	overflow: hidden;

	&.fullscreen {
		z-index: 120;
		width: 100%;
		height: 100dvh;
		padding-bottom: env(safe-area-inset-bottom);
		box-shadow: none;
	}

	.header {
		display: flex;
		flex-shrink: 0;
		align-items: center;
		justify-content: space-between;
		gap: var(--spacing-sm);
		padding: var(--spacing-md);
		border-bottom: var(--border-width-thin) solid var(--neutral-100);

		.title {
			display: flex;
			align-items: center;
			gap: var(--spacing-sm);
			color: var(--neutral-900);
			font-family: var(--font-family-primary);
			font-size: var(--font-size-small);
			font-weight: var(--font-weight-semibold);

			.app-icon {
				color: var(--primary-green);
			}
		}

		.close-button {
			display: flex;
			flex-shrink: 0;
			align-items: center;
			justify-content: center;
			padding: var(--spacing-sm);
			border: none;
			border-radius: var(--border-radius-sm);
			background: none;
			color: var(--neutral-600);
			cursor: pointer;

			&:hover {
				background: var(--neutral-100);
				color: var(--neutral-900);
			}
		}
	}
}
</style>
